import React from 'react';
import { useEffect } from 'react';

export const useMediaQueries = ({onSmm, onMdm, onXl}) => {

    const onResize = () => {
        if(window.innerWidth < 500) {
            onSmm?.();
        }
        else if(window.innerWidth < 920){
            onSmm?.();
        }
        else if(window.innerWidth < 1250){
            onMdm?.();
        }
        else{
            onXl?.();
        }
    };

    useEffect(() => {
        onResize();
        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);
};